import path from 'path';

import { DEFINITION_ROUTE } from './pages/Definition';

export const segmentPath = (id: string) =>
  path.join('/segments', id.toString(), DEFINITION_ROUTE.path);
export const SEGMENT_PATH = segmentPath(':id');
